import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section
      id="hero"
      className="min-h-screen flex flex-col justify-center items-center text-center bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 relative overflow-hidden"
    >
      {/* animated background shapes could be implemented with canvas or css animations */}
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-4xl md:text-6xl font-extrabold text-white mb-4"
      >
        Building Intelligent Technology for Communities and Businesses
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
        className="text-lg md:text-2xl text-gray-300 max-w-2xl mb-8"
      >
        Munorva develops AI-powered systems, communication platforms, and
        advanced digital solutions designed for the future.
      </motion.p>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="flex space-x-4"
      >
        <a
          href="#products"
          className="px-6 py-3 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-md text-white font-medium hover:from-blue-500 hover:to-cyan-400 transition"
        >
          Explore Our Work
        </a>
        <a
          href="#contact"
          className="px-6 py-3 border border-cyan-400 rounded-md text-cyan-400 hover:bg-cyan-500 hover:text-white transition"
        >
          Contact Us
        </a>
      </motion.div>
    </section>
  );
};

export default Hero;
